import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import Moment from 'react-moment';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import { withStyles } from '@material-ui/core/styles';

import indigo from '@material-ui/core/colors/indigo';

import pdfLogo from '../../../../img/files/pdf.png';
import defaultLogo from '../../../../img/files/default.png';
import wordLogo from '../../../../img/files/word.png';
import xlsLogo from  '../../../../img/files/xls.png';

import {
  startRemoveFile,
} from '../../../../store/actions/files';

const styles = theme => ({
  root:{
    margin: theme.spacing.unit*2,
    width: '300px',
  },
  content: {
    backgroundColor: indigo[50],
    display: 'flex',
    justifyContent: 'center',
  },
  image: {
    maxWidth: '150px',
    maxHeight: '150px',
  }
});


const JobPhotoCard = ({classes, file, startRemoveFile}) => {

  return(
    <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar className={classes.avatar}>
            F
          </Avatar>
        }
        title={file.title}
      />
      <CardContent className={classes.content}>
          <img className={classes.image} src={file.downloadURL} />
      </CardContent>
      <CardActions>
        <Button href={file.downloadURL}>
          Download
        </Button>
        <Button onClick={() => startRemoveFile(file.id)}>
          Delete
        </Button>
      </CardActions>
    </Card>

  );
};

const mapDispatchToProps = (dispatch) => ({
  startRemoveFile: (id) => dispatch(startRemoveFile(id)),
});

export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps),
)(JobPhotoCard);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Photos/JobPhotoCard.jsx